import {
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createElementVNode as _$ce,
} from 'intact';
import {BubbleList, Copy, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-refresh'
};
var _$tmp1 = {
    'className': 'k-icon-clone'
};
var _$tmp2 = {
    'type': 'button'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(BubbleList, {
        'className': 'bubble-list-demo-slots',
        'items': this.get('items'),
        'roles': this.get('roles'),
        '$blocks': function($blocks) {
            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
            return (
                (
                    (_$blocks['header'] = function($super) {
                        return (
                            _$ce(2, 'div', '项目讨论群 · 2 人在线', 16, 'bubble-list-demo-slots-header')
                        );
                    }),
                    (__$blocks['header'] = function($super, data) {
                        var block = $blocks['header'];
                        var callBlock = function() {
                            return _$blocks['header'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['footer'] = function($super, scope) {
                        return (
                            _$ce(2, 'div', [
                                _$ce(2, 'button', (
                                    _$cc(Icon, _$tmp0)
                                ), 2, 'bubble-list-demo-slots-icon', {
                                    'type': 'button',
                                    'ev-click': this.retry.bind(this, scope.item)
                                }),
                                _$cc(Copy, {
                                    'text': String(scope.item.content || ''),
                                    'children': (
                                        _$ce(2, 'button', (
                                            _$cc(Icon, _$tmp1)
                                        ), 2, 'bubble-list-demo-slots-icon', _$tmp2)
                                    )
                                })
                            ], 4, 'bubble-list-demo-slots-footer')
                        );
                    }),
                    (__$blocks['footer'] = function($super, data) {
                        var block = $blocks['footer'];
                        var callBlock = function() {
                            return _$blocks['footer'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['extra'] = function($super, scope) {
                        return (
                            _$ce(2, 'div', (
                                (scope.item.role === 'ai') ?
                                    _$ce(2, 'span', '生成完成', 16) :
                                    _$ce(2, 'span', '已发送', 16)
                            ), 2, 'bubble-list-demo-slots-extra')
                        );
                    }),
                    (__$blocks['extra'] = function($super, data) {
                        var block = $blocks['extra'];
                        var callBlock = function() {
                            return _$blocks['extra'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['scrollToBottom'] = function($super, scope) {
                        return (
                            _$ce(2, 'button', '\n            查看最新消息\n        ', 16, 'bubble-list-demo-slots-back', {
                                'type': 'button',
                                'ev-click': scope.scrollToBottom
                            })
                        );
                    }),
                    (__$blocks['scrollToBottom'] = function($super, data) {
                        var block = $blocks['scrollToBottom'];
                        var callBlock = function() {
                            return _$blocks['scrollToBottom'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                (
                    (_$blocks['listFooter'] = function($super) {
                        return (
                            _$ce(2, 'div', '以上内容仅用于演示。', 16, 'bubble-list-demo-slots-list-footer')
                        );
                    }),
                    (__$blocks['listFooter'] = function($super, data) {
                        var block = $blocks['listFooter'];
                        var callBlock = function() {
                            return _$blocks['listFooter'].call($this, $super, data);
                        };
                        return block ?
                            block.call($this, callBlock, data) :
                            callBlock();
                    })
                ),
                __$blocks
            );
        }.call($this, _$em)
    });
};